import { fromJS } from 'immutable';
import * as actions from '../../actions/appraisalDemo/zillow';
import { fetchingState } from '../../constants';

const initialStats = {
  zestimate: {},
  zProperty: {},
  zComps: {},
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case actions.ZILLOW_ZESTIMATE_FETCH_START:
      return state.setIn(['zestimate', 'state'], fetchingState.FETCHING);
    case actions.ZILLOW_ZESTIMATE_FETCH_SUCCESS:
      let newState = state.setIn(['zestimate', 'state'], fetchingState.LOADED);
      return newState.setIn(['zestimate', 'data'], fromJS(action.data.results));
    case actions.ZILLOW_ZESTIMATE_FETCH_ERROR:
      return state.setIn(['zestimate', 'state'], fetchingState.ERROR);

    case actions.ZILLOW_ZPROPERTY_FETCH_START:
      return state.setIn(['zProperty', 'state'], fetchingState.FETCHING);
    case actions.ZILLOW_ZPROPERTY_FETCH_SUCCESS:
      newState = state.setIn(['zProperty', 'state'], fetchingState.LOADED);
      return newState.setIn(['zProperty', 'data'], fromJS(action.data.results));
    case actions.ZILLOW_ZPROPERTY_FETCH_ERROR:
      return state.setIn(['zProperty', 'state'], fetchingState.ERROR);

    case actions.ZILLOW_ZCOMPS_FETCH_START:
      return state.setIn(['zComps', 'state'], fetchingState.FETCHING);
    case actions.ZILLOW_ZCOMPS_FETCH_SUCCESS:
      newState = state.setIn(['zComps', 'state'], fetchingState.LOADED);
      return newState.setIn(['zComps', 'data'], fromJS(action.data.results));
    case actions.ZILLOW_ZCOMPS_FETCH_ERROR:
      return state.setIn(['zComps', 'state'], fetchingState.ERROR);
    default:
      return state;
  }
};
